export default function FromNow({ time }) {
  const [key, setKey] = useState(null)

  useEffect(() => {
    setKey(uuid())
    const interval = setInterval(() => {
      setKey(uuid())
    }, 30 * 1000)
    return () => clearInterval(interval)
  }, [])

  if (!key) return null

  return <div>{ dayjs(time).fromNow() }</div>
}
